import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'CONFERENCIA_CHECKLIST_MODO_TELA',
        payload: {
			modo: modo,
			registro: {
				...registro

			}
		}
    };
}

export function setFiltro(filtro) {
	return {
		type: 'CONFERENCIA_CHECKLIST_FILTRO',
		payload: filtro,
	};
}

export function initForm(registro = {}) {
    return [
        initialize('conferenciaChecklistForm', {
			...registro
		})
    ];
}

export function setAguardando(aguardando) {
    return {
        type: 'CONFERENCIA_CHECKLIST_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function setChecklist(registro) {
    return (dispatch, getState) => {
		dispatch(setAguardando(true));
		axios.get(`${consts.API_URL}/checklistResposta/buscar?id=${registro.id}`).then(resp => {
			
			dispatch(initForm({
				...resp.data
			}));
			dispatch(setModoTela('cadastro', {
				...resp.data[0]
			}));
			dispatch(setAguardando(false));
		}).catch(ex => {
			console.log(ex);
			dispatch(setAguardando(false));
		});
	};
}

export function getLista() {

	return (dispatch, getState) => {
		dispatch(setAguardando(true));
		axios.get(`${consts.API_URL}/checklistResposta/conferencia?padrao=true
			&data_inicial=${DateFormat.formatarDataTelaParaSql(getState().conferenciaChecklist.filtro.data_inicial) == 'Invalid DateTime' ? null : DateFormat.formatarDataTelaParaSql(getState().conferenciaChecklist.filtro.data_inicial)}
			&data_final=${DateFormat.formatarDataTelaParaSql(getState().conferenciaChecklist.filtro.data_final) == 'Invalid DateTime' ? null : DateFormat.formatarDataTelaParaSql(getState().conferenciaChecklist.filtro.data_final)}
		`).then(resp => {
			dispatch({
				type: 'CONFERENCIA_CHECKLIST_LISTADO',
				payload: resp
			});
			dispatch(setAguardando(false));
		}).catch(ex => {
			console.log(ex);
			dispatch(setAguardando(false));
		});
	};

}

export function salvar(registro) {

    return (dispatch, getState) => {
		dispatch(setAguardando(true));
		axios.put(`${consts.API_URL}/checklistResposta/alterarImagem`, {
			...registro,
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(async resp => {
			
			dispatch(setChecklist(registro));

		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	};
}

export function salvarConferido(registro) {

    return (dispatch, getState) => {
		dispatch(setAguardando(true));
		axios.put(`${consts.API_URL}/checklistResposta/conferencia`, {
			...registro,
			conferido: !registro.conferido,
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(async resp => {
			
			dispatch(getLista());
			dispatch(setModoTela('lista'));
			dispatch(setAguardando(false));

		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	};
}

export function baixarImagem(imagem, nome) {
	return dispatch => {
		if (imagem) {
			const linkSource = imagem;
			const downloadLink = document.createElement("a");
			const fileName = `${nome}.jpg`;
			downloadLink.href = linkSource;
			downloadLink.download = fileName;
			downloadLink.click();
		}
	};
}